import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import { iconManhole, iconFobCanton, iconCouplingCanton, iconPonBox, iconPillar } from '../Constants/ConstantsOptics';
import React, { useState, useRef, useEffect} from "react";
import './styleModal.css';
import { CABLE, WELL, PILLAR, COUPLING, FOB, PON_BOX } from '../Constants/ConstantsOptics';
import { GetComponentCable, GetComponentWell, GetComponentPillar, GetComponentPonBox,
  GetComponentCoupling, GetComponentFob, 
  GetComponentFobByCoords,
  GetComponentCouplingByCoords,
  GetComponentPonBoxByCoords,
  GetComponentPillarByCoords,
  GetComponentWellByCoords,
  GetComponentCableByCoords} from '../GetComponent/GetComponent';
import { TerritoryLabel } from '../Dialog/DialogDescriptionComponent/TerritoryLabel ';
import { UpdateStatusComponents, UpdateStatusComponentsModalSearch } from '../UpdateData/UpdateStatusComponent';
import CustomSnackbar from '../Components/CustomSnackbar';

const ModalSearchComponentMap = ({ open, onClose, user }) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const mapRef = useRef();

  const [selectedComponent, setSelectedComponent] = useState('');
  const [inputId, setInputId] = useState('');
  const [isVisibleDescription, setIsVisibleDescription] = useState(false);
  const [context, setContext] = useState([]);


  const [coordinates, setCoordinates] = useState([]);
  const [color, setColor] = useState('');
  const [type, setType] = useState('');
  const [width, setWidth] = useState('');
  const [cableName, setCableName] = useState('');
  const [cableFiberQuantity, setCableFiberQuantity] = useState('');
  const [cableTypeType, setCableTypeType] = useState('');
  const [city, setCity] = useState('');
  const [contractorName, setContractorName] = useState('');
  const [rankCableName, setRankCableName] = useState('');
  const [lengthCable, setLengthCable] = useState('');
  const [description, setDescription] = useState('');
  const [statusCable, setStatusCable] = useState('');
  const [authorId, setAuthorId] = useState('');

  const [cityWell, setCityWell] = useState('');
  const [ownerWellName, setOwnerWellName] = useState('');
  const [latitudeWell, setLatitudeWell] = useState('');
  const [longitudeWell, setLongitudeWell] = useState('');
  const [descriptionWell, setDescriptionWell] = useState('');
  const [authorIdWell, setAuthorIdWell] = useState('');
  const [cantonWell, setCantonWell] = useState('');
  const [regionWell, setRegionWell] = useState('');
  const [areaWell, setAreaWell] = useState('');
  const [statusWell, setStatusWell] = useState('');


  const [cityPillar, setCityPillar] = useState('');
  const [ownerPillarName, setOwnerPillarName] = useState('');
  const [latitudePillar, setLatitudePillar] = useState('');
  const [longitudePillar, setLongitudePillar] = useState('');
  const [descriptionPillar, setDescriptionPillar] = useState('');
  const [authorIdPillar, setAuthorIdPillar] = useState('');
  const [cantonPillar, setCantonPillar] = useState('');
  const [regionPillar, setRegionPillar] = useState('');
  const [areaPillar, setAreaPillar] = useState('');
  const [statusPillar, setStatusPillar] = useState('');

  const [cityPonBox, setCityPonBox] = useState('');
  const [ponBoxName, setPonBoxName] = useState('');
  const [latitudePonBox, setLatitudePonBox] = useState('');
  const [longitudePonBox, setLongitudePonBox] = useState('');
  const [descriptionPonBox, setDescriptionPonBox] = useState('');
  const [authorIdPonBox, setAuthorIdPonBox] = useState('');
  const [rankComponentNamePonBox, setRankComponentNamePonBox] = useState('');
  const [cantonPonBox, setCantonPonBox] = useState('');
  const [regionPonBox, setRegionPonBox] = useState('');
  const [areaPonBox, setAreaPonBox] = useState('');
  const [statusPonBox, setStatusPonBox] = useState('');

  const [cityCoupling, setCityCoupling] = useState('');
  const [couplingName, setCouplingName] = useState('');
  const [latitudeCoupling, setLatitudeCoupling] = useState('');
  const [longitudeCoupling, setLongitudeCoupling] = useState('');
  const [descriptionCoupling, setDescriptionCoupling] = useState('');
  const [authorIdCoupling, setAuthorIdCoupling] = useState('');
  const [rankComponentNameCoupling, setRankComponentNameCoupling] = useState('');
  const [cantonCoupling, setCantonCoupling] = useState('');
  const [regionCoupling, setRegionCoupling] = useState('');
  const [areaCoupling, setAreaCoupling] = useState('');
  const [statusCoupling, setStatusCoupling] = useState('');
  

  const [cityFob, setCityFob] = useState('');
  const [fobName, setFobName] = useState('');
  const [latitudeFob, setLatitudeFob] = useState('');
  const [longitudeFob, setLongitudeFob] = useState('');
  const [descriptionFob, setDescriptionFob] = useState('');
  const [authorIdFob, setAuthorIdFob] = useState('');
  const [rankComponentNameFob, setRankComponentNameFob] = useState('');
  const [cantonFob, setCantonFob] = useState('');
  const [regionFob, setRegionFob] = useState('');
  const [areaFob, setAreaFob] = useState('');
  const [statusFob, setStatusFob] = useState('');

  const [searchByCoords, setSearchByCoords] = useState(false);
  const [coordsInput, setCoordsInput] = useState('');

  const [loadingCoords, setLoadingCoords] = useState(false);
  const [loadingId, setLoadingId] = useState(false);


  const handleClose = () => {
    onClose();
    setSelectedComponent('');
    setInputId('');
    resetAllState();
    setIsVisibleDescription(false)
    setSearchByCoords(false);
  };

  const descriptionComponents = async () => {

    try {
     setLoadingId(true); // старт загрузки

    if(selectedComponent== CABLE){

    await GetComponentCable(inputId, (cableData) => {
            setIsVisibleDescription(true)

      const cable = cableData[inputId];

      if (cable) {
        setCoordinates(cable.coordinates);
        setColor(cable.color);
        setWidth(cable.width);
        setType(cable.type);
  
        if (cable.coordinates && cable.coordinates.length > 0) {
          const bounds = cable.coordinates.map((coord) => [coord[0], coord[1]]);
          mapRef.current?.fitBounds(bounds); 
        }
      }
  }, (descriptionOptic) => {
                 

      if (Array.isArray(descriptionOptic) && descriptionOptic.length > 0) {
        setCableName(descriptionOptic[0].cableName);
        setCableFiberQuantity(descriptionOptic[0].cableFiberQuantity);
        setCableTypeType(descriptionOptic[0].cableTypeType);
        setCity(descriptionOptic[0].city);
        setContractorName(descriptionOptic[0].contractorName);
        setRankCableName(descriptionOptic[0].rankCableName);
        setLengthCable(descriptionOptic[0].lengthCable);
        setDescription(descriptionOptic[0].description);
        setAuthorId(descriptionOptic[0].authorId);
        setStatusCable(descriptionOptic[0].status);

      }
  
  }, (context) => {
    setContext(context);
  });

 
}else if(selectedComponent== WELL){
    
  await GetComponentWell(inputId, (wellData) => {
    
    if (wellData && wellData.length > 0) {
        setIsVisibleDescription(true)
      const well = wellData[0]; 
  
      setCityWell(well.city);
      setOwnerWellName(well.ownerWellName);
      setLatitudeWell(well.latitude);
      setLongitudeWell(well.longitude);
      setDescriptionWell(well.description);
      setAuthorIdWell(well.authorId);
      setCantonWell(well.canton);
      setRegionWell(well.region);
      setAreaWell(well.area);
      setStatusWell(well.status);
  
      if (well.latitude && well.longitude) {
        mapRef.current?.setView([well.latitude, well.longitude], 18); 
      } else {
        console.error('Latitude or Longitude is undefined');
      }
    }
});
}else if(selectedComponent== PILLAR){
    
  await GetComponentPillar(inputId, (pillarData) => {
    
    if (pillarData && pillarData.length > 0) {
        setIsVisibleDescription(true)
      const pillar = pillarData[0]; 
  
      setCityPillar(pillar.city);
      setOwnerPillarName(pillar.ownerPillarName);
      setLatitudePillar(pillar.latitude);
      setLongitudePillar(pillar.longitude);
      setDescriptionPillar(pillar.description);
      setAuthorIdPillar(pillar.authorId);
      setCantonPillar(pillar.canton);
      setRegionPillar(pillar.region);
      setAreaPillar(pillar.area);
      setStatusPillar(pillar.status);
  
      if (pillar.latitude && pillar.longitude) {
        mapRef.current?.setView([pillar.latitude, pillar.longitude], 18); 
      } else {
        console.error('Latitude or Longitude is undefined');
      }
    }
});
}else if(selectedComponent== PON_BOX){
    
  await GetComponentPonBox(inputId, (ponBoxData) => {
    
    if (ponBoxData && ponBoxData.length > 0) {
        setIsVisibleDescription(true)
      const ponBox = ponBoxData[0]; 
  
      setCantonPonBox(ponBox.canton);
      setPonBoxName(ponBox.fobName);
      setLatitudePonBox(ponBox.latitude);
      setLongitudePonBox(ponBox.longitude);
      setDescriptionPonBox(ponBox.description);
      setAuthorIdPonBox(ponBox.authorId);
      setRankComponentNamePonBox(ponBox.rankComponentName);
      setRegionPonBox(ponBox.region);
      setAreaPonBox(ponBox.area);
      setCityPonBox(ponBox.city);
      setStatusPonBox(ponBox.status);
  
      if (ponBox.latitude && ponBox.longitude) {
        mapRef.current?.setView([ponBox.latitude, ponBox.longitude], 18); 
      } else {
        console.error('Latitude or Longitude is undefined');
      }
    }
});
}else if(selectedComponent== COUPLING){
    
  await GetComponentCoupling(inputId, (couplingData) => {
    
    if (couplingData && couplingData.length > 0) {
        setIsVisibleDescription(true)
      const coupling = couplingData[0]; 
  
      setCityCoupling(coupling.city);
      setCouplingName(coupling.couplingName);
      setLatitudeCoupling(coupling.latitude);
      setLongitudeCoupling(coupling.longitude);
      setDescriptionCoupling(coupling.description);
      setAuthorIdCoupling(coupling.authorId);
      setRankComponentNameCoupling(coupling.rankComponentName);
      setCantonCoupling(coupling.canton);
      setRegionCoupling(coupling.region);
      setAreaCoupling(coupling.area);
      setStatusCoupling(coupling.status);
  
      if (coupling.latitude && coupling.longitude) {
        mapRef.current?.setView([coupling.latitude, coupling.longitude], 18); 
      } else {
        console.error('Latitude or Longitude is undefined');
      }
    }
});
}else if(selectedComponent== FOB){
    
  await GetComponentFob(inputId, (fobData) => {
    
    if (fobData && fobData.length > 0) {
        setIsVisibleDescription(true)
      const fob = fobData[0]; 
  
      setCityFob(fob.city);
      setFobName(fob.fobName);
      setLatitudeFob(fob.latitude);
      setLongitudeFob(fob.longitude);
      setDescriptionFob(fob.description);
      setAuthorIdFob(fob.authorId);
      setRankComponentNameFob(fob.rankComponentName);
      setCantonFob(fob.canton);
      setRegionFob(fob.region);
      setAreaFob(fob.area);
      setStatusFob(fob.status);

  
      if (fob.latitude && fob.longitude) {
        mapRef.current?.setView([fob.latitude, fob.longitude], 18); 
      } else {
        console.error('Latitude or Longitude is undefined');
      }
    }
});

}else{
  console.log("шляпа какая-то!");
  setSelectedComponent('');
  setInputId('');
}

 } catch (e) {
    console.error(e);
  } finally {
    setLoadingId(false); // стоп загрузки
  }
  };

  const handleChangeCableSelect = (event) => {
    const selectedCable = event.target.value;
    setSelectedComponent(selectedCable)
    resetAllState();  
  };

  const resetAllState = () => {
    // Cable states
    setCoordinates([]);
    setColor('');
    setWidth('');
    setType('');
    setCableName('');
    setCableFiberQuantity('');
    setCableTypeType('');
    setCity('');
    setContractorName('');
    setRankCableName('');
    setLengthCable('');
    setDescription('');
    setAuthorId('');
    setStatusCable('');

    // Well states
    setCityWell('');
    setOwnerWellName('');
    setLatitudeWell('');
    setLongitudeWell('');
    setDescriptionWell('');
    setAuthorIdWell('');
    setCantonWell('');
    setRegionWell('');
    setAreaWell('');

    // Pillar states
    setCityPillar('');
    setOwnerPillarName('');
    setLatitudePillar('');
    setLongitudePillar('');
    setDescriptionPillar('');
    setAuthorIdPillar('');
    setCantonPillar('');
    setRegionPillar('');
    setAreaPillar('');
    setStatusPillar('');

    // PonBox states
    setCantonPonBox('');
    setPonBoxName('');
    setLatitudePonBox('');
    setLongitudePonBox('');
    setDescriptionPonBox('');
    setAuthorIdPonBox('');
    setRankComponentNamePonBox('');
    setRegionPonBox('');
    setAreaPonBox('');
    setCityPonBox('');
    setStatusPonBox('');

    // Coupling states
    setCityCoupling('');
    setCouplingName('');
    setLatitudeCoupling('');
    setLongitudeCoupling('');
    setDescriptionCoupling('');
    setAuthorIdCoupling('');
    setRankComponentNameCoupling('');
    setCantonCoupling('');
    setRegionCoupling('');
    setAreaCoupling('');
    setStatusCoupling('');

    // FOB states
    setCityFob('');
    setFobName('');
    setLatitudeFob('');
    setLongitudeFob('');
    setDescriptionFob('');
    setAuthorIdFob('');
    setRankComponentNameFob('');
    setCantonFob('');
    setRegionFob('');
    setAreaFob('');
    setStatusFob('');

    setCoordsInput('');
    setIsVisibleDescription(false);
};

  useEffect(() => {
    resetAllState();
  }, [searchByCoords]);

const handleSearchByCoords = async () => {
  if (!coordsInput) return;

  const [lat, lng] = coordsInput.split(',').map(v => parseFloat(v.trim()));

  if (isNaN(lat) || isNaN(lng)) {
    console.error('Неверный формат координат');
    return;
  }

   try {
    setLoadingCoords(true); //старт загрузки

  // 🔽 дальше почти копия твоей логики
 if (selectedComponent == CABLE) {

 await GetComponentCableByCoords(
  lat,
  lng,
  (cableData) => {
    setIsVisibleDescription(true);


   // 🔥 как в ID
    const firstKey = Object.keys(cableData)[0];
    const cable = cableData[firstKey];

    if (cable) {
      setCoordinates(cable.coordinates);
      setColor(cable.color);
      setWidth(cable.width);
      setType(cable.type);


       if (cable.coordinates?.length > 0) {
        const bounds = cable.coordinates.map((coord) => [
          coord[0],
          coord[1],
        ]);

        mapRef.current?.fitBounds(bounds);
      }
    }
  },
  (descriptionOptic) => {
    if (Array.isArray(descriptionOptic) && descriptionOptic.length > 0) {
      setCableName(descriptionOptic[0].cableName);
      setCableFiberQuantity(descriptionOptic[0].cableFiberQuantity);
      setCableTypeType(descriptionOptic[0].cableTypeType);
      setCity(descriptionOptic[0].city);
      setContractorName(descriptionOptic[0].contractorName);
      setRankCableName(descriptionOptic[0].rankCableName);
      setLengthCable(descriptionOptic[0].lengthCable);
      setDescription(descriptionOptic[0].description);
      setAuthorId(descriptionOptic[0].authorId);
      setStatusCable(descriptionOptic[0].status);
    }
  },
  (context) => {
    setContext(context);
  }
);

  } else if (selectedComponent == WELL) {

    await GetComponentWellByCoords(lat, lng, (wellData) => {
      if (wellData?.length > 0) {
        setIsVisibleDescription(true);
        const well = wellData[0];

        setCityWell(well.city);
        setOwnerWellName(well.ownerWellName);
        setLatitudeWell(well.latitude);
        setLongitudeWell(well.longitude);
        setDescriptionWell(well.description);
        setAuthorIdWell(well.authorId);
        setCantonWell(well.canton);
        setRegionWell(well.region);
        setAreaWell(well.area);
        setStatusWell(well.status);

        mapRef.current?.setView([well.latitude, well.longitude], 18);
      }
    });

  } else if (selectedComponent == PILLAR) {

    await GetComponentPillarByCoords(lat, lng, (pillarData) => {
      if (pillarData?.length > 0) {
        setIsVisibleDescription(true);
        const pillar = pillarData[0];

        setCityPillar(pillar.city);
        setOwnerPillarName(pillar.ownerPillarName);
        setLatitudePillar(pillar.latitude);
        setLongitudePillar(pillar.longitude);
        setDescriptionPillar(pillar.description);
        setAuthorIdPillar(pillar.authorId);
        setCantonPillar(pillar.canton);
        setRegionPillar(pillar.region);
        setAreaPillar(pillar.area);
        setStatusPillar(pillar.status);

        mapRef.current?.setView([pillar.latitude, pillar.longitude], 18);
      }
    });

  } else if (selectedComponent == PON_BOX) {

    await GetComponentPonBoxByCoords(lat, lng, (data) => {
      if (data?.length > 0) {
        setIsVisibleDescription(true);
        const ponBox = data[0];

        setCantonPonBox(ponBox.canton);
        setPonBoxName(ponBox.fobName);
        setLatitudePonBox(ponBox.latitude);
        setLongitudePonBox(ponBox.longitude);
        setDescriptionPonBox(ponBox.description);
        setAuthorIdPonBox(ponBox.authorId);
        setRankComponentNamePonBox(ponBox.rankComponentName);
        setRegionPonBox(ponBox.region);
        setAreaPonBox(ponBox.area);
        setCityPonBox(ponBox.city);
        setStatusPonBox(ponBox.status);

        mapRef.current?.setView([ponBox.latitude, ponBox.longitude], 18);
      }
    });

  } else if (selectedComponent == COUPLING) {

    await GetComponentCouplingByCoords(lat, lng, (data) => {
      if (data?.length > 0) {
        setIsVisibleDescription(true);
        const coupling = data[0];

        setCityCoupling(coupling.city);
        setCouplingName(coupling.couplingName);
        setLatitudeCoupling(coupling.latitude);
        setLongitudeCoupling(coupling.longitude);
        setDescriptionCoupling(coupling.description);
        setAuthorIdCoupling(coupling.authorId);
        setRankComponentNameCoupling(coupling.rankComponentName);
        setCantonCoupling(coupling.canton);
        setRegionCoupling(coupling.region);
        setAreaCoupling(coupling.area);
        setStatusCoupling(coupling.status);

        mapRef.current?.setView([coupling.latitude, coupling.longitude], 18);
      }
    });

  } else if (selectedComponent == FOB) {

    await GetComponentFobByCoords(lat, lng, (data) => {
      if (data?.length > 0) {
        setIsVisibleDescription(true);
        const fob = data[0];

        setCityFob(fob.city);
        setFobName(fob.fobName);
        setLatitudeFob(fob.latitude);
        setLongitudeFob(fob.longitude);
        setDescriptionFob(fob.description);
        setAuthorIdFob(fob.authorId);
        setRankComponentNameFob(fob.rankComponentName);
        setCantonFob(fob.canton);
        setRegionFob(fob.region);
        setAreaFob(fob.area);
        setStatusFob(fob.status);

        mapRef.current?.setView([fob.latitude, fob.longitude], 18);
      }
    });

  } else {
    console.log("шляпа какая-то!");
    setSelectedComponent('');
    setCoordsInput('');
  }
} catch (e) {
    console.error(e);
} finally {
    setLoadingCoords(false); // стоп загрузки
  }
};

const deleteComponent = () => {
  UpdateStatusComponentsModalSearch(selectedComponent, inputId, showSnackbar, user, setSelectedComponent, setInputId, resetAllState);
};

  return (
    <Dialog open={open} className="modalStyle"  fullWidth maxWidth={false}>
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff' }}>Поиск компонента</label>
        <hr className="horizontalLineModal" />
        <div style={{
            alignItems: 'center',
            gap: '10px',
            flexWrap: 'wrap' // чтобы не ломалось на маленьком экране
          }}>

           <select
              className="selectStyleModalDescription"
              value={selectedComponent}
              onChange={(event) => {
                handleChangeCableSelect(event);
            }} 
            >
              <option value="">Тип компонента</option>
              <option value={PILLAR}>Опора</option>
              <option value={WELL}>Колодец</option>
              <option value={COUPLING}>Муфта</option>
              <option value={FOB}>Фоб</option>
              <option value={CABLE}>Кабель</option>
              <option value={PON_BOX}>Пон-бокс</option>
          </select>


           
          {/* если НЕ координаты → старый поиск */}
            {!searchByCoords && (
              <>
              
                <input
                  type="number"
                  placeholder="Введите ID"
                  className="inputDescriptionModal"
                  style={{marginTop: '0px'}}
                  value={inputId}
                  onChange={(e) => setInputId(e.target.value)}
                />

                <button 
                  className="buttonIsDescriptionModal" 
                  onClick={descriptionComponents} 
                  style={{textShadow: '2px 2px 4px #242424'}}
                  disabled={loadingId}
                >
                  {loadingCoords ? "Загрузка..." : "Поиск"}
                </button>

                </>
              )}

          {/* если координаты → новый режим */}
          {searchByCoords && (
            <>
              <input
                type="text"
                placeholder="50.37967122568714,30.4539567232132"
                className="inputDescriptionModal"
                value={coordsInput}
                style={{width: '400px'}}
                onChange={(e) => setCoordsInput(e.target.value)}
              />

              <button
                className="buttonIsDescriptionModal"
                onClick={handleSearchByCoords}
                disabled={loadingCoords}
              >
                {loadingCoords ? "Загрузка..." : "Поиск по координатам"}
              </button>
            </>
          )}

           {/* чекбокс */}
            <label  
              style={{
                display: 'flex',
                alignItems: 'center',   // 🔥 выравнивание по вертикали
                gap: '8px',             // отступ между чекбоксом и текстом
                marginBottom: '10px',
                color: '#e0e0e0',          // 🔥 нужный цвет текста
                cursor: 'pointer'
              }}>
              <input
                type="checkbox"
                checked={searchByCoords}
                onChange={(e) => setSearchByCoords(e.target.checked)}
              />
              Поиск по координатам
            </label>

        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>

          <div style={{ height: '600px', width: '1140px', borderRadius: '10px', marginTop: '10px', flex: 2 }}>
            <MapContainer
            center={[50.45018, 30.52294]}
            zoom={12}
            minZoom={12}
            style={{ height: '100%', width: '100%', borderRadius: '10px' }}
            ref={mapRef}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
            />

            {coordinates.length > 0 && (
              <Polyline
                positions={coordinates}
                pathOptions={{
                  color: color,  
                  weight: width, 
                  dashArray: type !== 'solid ' ? '5,10' : null 
                }}
              />
            )}

              <Marker
                icon={iconManhole}
                position={[latitudeWell, longitudeWell]}
              >
                 <Popup className="custom-popup">
                  <div>
                    <h5>Колодец</h5>
                  </div>
                </Popup>
              </Marker>

              <Marker
                icon={iconPillar}
                position={[latitudePillar, longitudePillar]}
              >
                 <Popup className="custom-popup">
                  <div>
                    <h5>Опора</h5>
                  </div>
                </Popup>
              </Marker>

              <Marker
                icon={iconPonBox}
                position={[latitudePonBox, longitudePonBox]}
              >
                 <Popup className="custom-popup">
                  <div>
                    <h5>Пон-бокс</h5>
                  </div>
                </Popup>
              </Marker>

              <Marker
                icon={iconCouplingCanton}
                position={[latitudeCoupling, longitudeCoupling]}
              >
                 <Popup className="custom-popup">
                  <div>
                    <h5>Муфта</h5>
                  </div>
                </Popup>
              </Marker>

              <Marker
                icon={iconFobCanton}
                position={[latitudeFob, longitudeFob]}
              >
                 <Popup className="custom-popup">
                  <div>
                    <h5>Фоб</h5>
                  </div>
                </Popup>
              </Marker>
          </MapContainer>
        
    </div>
      {/* Блок с текстом Cable */}
      {(isVisibleDescription && selectedComponent === CABLE) && (

        <div style={{ flex: 1, marginRight: '10px', marginLeft: '10px', border: '1px solid gray',  borderRadius: '8px',  boxShadow: '2px 2px 6px black', padding: '10px', marginTop: '5px' }}>
          <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff'  }}>Описание</label>
           <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Город: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{city}</span> </label>
           <TerritoryLabel content={context[0]}/>
          
           <hr className="horizontalLineModal" />
           <label style={{ color: '#292929', fontWeight: 'bold' }}>Кабель: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cableName}</span></label>
          <br />
          <label style={{ color: '#292929', fontWeight: 'bold'}}>Количество волокон: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cableFiberQuantity}</span></label>
          <br/>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>Тип: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cableTypeType}</span></label>
          <br/>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина кабеля: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{lengthCable} м.</span></label>
          <hr className='horizontalLineDialog2'/>
          <label style={{ color: '#292929', fontWeight: 'bold'}}>Принадлежность к узлам: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{rankCableName}</span></label>
          <br/>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>Подрядчик: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{contractorName}</span></label>
          <br/>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>Внес: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{authorId}</span></label>
          
          <br />
          <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{description}</span></label>
          <hr className="horizontalLineModal" />
          {statusCable !== 1 && (
            <label style={{ color: '#292929', fontWeight: 'bold'}}>
              Статус:{' '}
              <span
                style={{
                  color: statusCable === 0 ? '#f55a5aff' : '#bebebe',
                  fontWeight: 'normal',
                  textShadow: '2px 2px 4px #000000ff'
                }}
              >
                {statusCable === 0 ? 'Удален' : statusCable}
              </span>
            </label>
          )}
         {/* Блок удаления — виден только если статус 1 и автор совпадает */}
            {statusCable === 1 && user === authorId && (
              <>
                <button 
                  className="buttonIsDeleteModal" 
                  onClick={deleteComponent} 
                  style={{ 
                    fontSize: "14px", 
                    width: "60px", 
                    padding: "2px", 
                    textShadow: '2px 2px 4px rgb(61, 61, 61)' 
                  }}
                >
                  Удалить
                </button>

                <span 
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#bebebe",
                    textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
                  }}
                >
                  Восстановление доступно в течение 24 часов
                </span>
              </>
            )}

          </div>
        )}
         {/* Блок с текстом Well */}
         {(isVisibleDescription && selectedComponent === WELL) && (
          <div style={{ flex: 1, marginRight: '10px', marginLeft: '10px', border: '1px solid gray',  borderRadius: '8px',  boxShadow: '2px 2px 6px black', padding: '10px', marginTop: '5px'  }}>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff' }}>Описание</label>
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Город: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cityWell}</span> </label>
            <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !cantonWell ? '#f55a5aff' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {cantonWell
                    ? regionWell && areaWell
                      ? `${cantonWell} ${regionWell} ${areaWell}`
                      : cantonWell
                    : 'нет'}
                </span>
              </label>     
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Собственник: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{ownerWellName}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Координаты: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{latitudeWell}, {longitudeWell}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Внес: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{authorIdWell}</span></label>
            <br />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{descriptionWell}</span></label>
             <hr className="horizontalLineModal" />
              {statusWell !== 1 && (
                <label style={{ color: '#292929', fontWeight: 'bold'}}>
                  Статус:{' '}
                  <span
                    style={{
                      color: statusWell === 0 ? '#f55a5aff' : '#bebebe',
                      fontWeight: 'normal',
                      textShadow: '2px 2px 4px #000000ff'
                    }}
                  >
                    {statusWell === 0 ? 'Удален' : statusWell}
                  </span>
                </label>
              )}

               {/* Блок удаления — виден только если статус 1 и автор совпадает */}
            {statusWell == 1 && user === authorIdWell && (
              <>
                <button 
                  className="buttonIsDeleteModal" 
                  onClick={deleteComponent} 
                  style={{ 
                    fontSize: "14px", 
                    width: "60px", 
                    padding: "2px", 
                    textShadow: '2px 2px 4px rgb(61, 61, 61)' 
                  }}
                >
                  Удалить
                </button>

                <span 
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#bebebe",
                    textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
                  }}
                >
                  Восстановление доступно в течение 24 часов
                </span>
              </>
            )}

            </div>
          )}
            {/* Блок с текстом Pillar */}
         {(isVisibleDescription && selectedComponent === PILLAR) && (

          <div style={{ flex: 1, marginRight: '10px', marginLeft: '10px', border: '1px solid gray',  borderRadius: '8px',  boxShadow: '2px 2px 6px black', padding: '10px', marginTop: '5px'}}>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff' }}>Описание</label>
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Город: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cityPillar}</span> </label>
            <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !cantonPillar ? '#f55a5aff' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {cantonPillar
                    ? regionPillar && areaPillar
                      ? `${cantonPillar} ${regionPillar} ${areaPillar}`
                      : cantonPillar
                    : 'нет'}
                </span>
              </label>     
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Собственник: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{ownerPillarName}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Координаты: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{latitudePillar}, {longitudePillar}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Внес: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{authorIdPillar}</span></label>       
            <br />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{descriptionPillar}</span></label>
             <hr className="horizontalLineModal" />
              {statusPillar !== 1 && (
                <label style={{ color: '#292929', fontWeight: 'bold'}}>
                  Статус:{' '}
                  <span
                    style={{
                      color: statusPillar === 0 ? '#f55a5aff' : '#bebebe',
                      fontWeight: 'normal',
                      textShadow: '2px 2px 4px #000000ff'
                    }}
                  >
                    {statusPillar === 0 ? 'Удален' : statusPillar}
                  </span>
                </label>
              )}
               {/* Блок удаления — виден только если статус 1 и автор совпадает */}
            {statusPillar === 1 && user === authorIdPillar && (
              <>
                <button 
                  className="buttonIsDeleteModal" 
                  onClick={deleteComponent} 
                  style={{ 
                    fontSize: "14px", 
                    width: "60px", 
                    padding: "2px", 
                    textShadow: '2px 2px 4px rgb(61, 61, 61)' 
                  }}
                >
                  Удалить
                </button>

                <span 
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#bebebe",
                    textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
                  }}
                >
                  Восстановление доступно в течение 24 часов
                </span>
              </>
            )}

            </div>
          )}

           {/* Блок с текстом Pon-box */}
         {(isVisibleDescription && selectedComponent === PON_BOX) && (
          <div style={{ flex: 1, marginRight: '10px', marginLeft: '10px', border: '1px solid gray',  borderRadius: '8px',  boxShadow: '2px 2px 6px black', padding: '10px', marginTop: '5px' }}>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff'  }}>Описание</label>
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Город: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff'  }}>{cityPonBox}</span> </label>
            <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !cantonPonBox ? '#f55a5aff' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {cantonPonBox
                    ? regionPonBox && areaPonBox
                      ? `${cantonPonBox} ${regionPonBox} ${areaPonBox}`
                      : cantonPonBox
                    : 'нет'}
                </span>
              </label>     
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Пон-бокс: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff'  }}>{ponBoxName}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Ранг: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff'  }}>{rankComponentNamePonBox}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Координаты: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff'  }}>{latitudePonBox}, {longitudePonBox}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Внес: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff'  }}>{authorIdPonBox}</span></label>
            
            <br />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff'  }}>{descriptionPonBox}</span></label>
            <hr className="horizontalLineModal" />
              {statusPonBox !== 1 && (
                <label style={{ color: '#292929', fontWeight: 'bold'}}>
                  Статус:{' '}
                  <span
                    style={{
                      color: statusPonBox === 0 ? '#f55a5aff' : '#bebebe',
                      fontWeight: 'normal',
                      textShadow: '2px 2px 4px #000000ff'
                    }}
                  >
                    {statusPonBox === 0 ? 'Удален' : statusPonBox}
                  </span>
                </label>
              )}
               {/* Блок удаления — виден только если статус 1 и автор совпадает */}
            {statusPonBox === 1 && user === authorIdPonBox && (
              <>
                <button 
                  className="buttonIsDeleteModal" 
                  onClick={deleteComponent} 
                  style={{ 
                    fontSize: "14px", 
                    width: "60px", 
                    padding: "2px", 
                    textShadow: '2px 2px 4px rgb(61, 61, 61)' 
                  }}
                >
                  Удалить
                </button>

                <span 
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#bebebe",
                    textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
                  }}
                >
                  Восстановление доступно в течение 24 часов
                </span>
              </>
            )}

            </div>
          )}

             {/* Блок с текстом Coupling */}
         {(isVisibleDescription && selectedComponent === COUPLING) && (
          <div style={{ flex: 1, marginRight: '10px', marginLeft: '10px', border: '1px solid gray',  borderRadius: '8px',  boxShadow: '2px 2px 6px black', padding: '10px', marginTop: '5px' }}>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff' }}>Описание</label>
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Город: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cityCoupling}</span> </label>
             <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !cantonCoupling ? '#f55a5aff' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {cantonCoupling
                    ? regionCoupling && areaCoupling
                      ? `${cantonCoupling} ${regionCoupling} ${areaCoupling}`
                      : cantonCoupling
                    : 'нет'}
                </span>
              </label>     
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Муфта: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{couplingName}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Ранг: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{rankComponentNameCoupling}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Координаты: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{latitudeCoupling}, {longitudeCoupling}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Внес: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{authorIdCoupling}</span></label>
            
            <br />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: <span style={{ color: '#bebebe', fontWeight: 'normal' ,textShadow: '2px 2px 4px #000000ff'}}>{descriptionCoupling}</span></label>
             <hr className="horizontalLineModal" />
              {statusCoupling !== 1 && (
                <label style={{ color: '#292929', fontWeight: 'bold'}}>
                  Статус:{' '}
                  <span
                    style={{
                      color: statusCoupling === 0 ? '#f55a5aff' : '#bebebe',
                      fontWeight: 'normal',
                      textShadow: '2px 2px 4px #000000ff'
                    }}
                  >
                    {statusCoupling === 0 ? 'Удален' : statusCoupling}
                  </span>
                </label>
              )}
               {/* Блок удаления — виден только если статус 1 и автор совпадает */}
            {statusCoupling === 1 && user === authorIdCoupling && (
              <>
                <button 
                  className="buttonIsDeleteModal" 
                  onClick={deleteComponent} 
                  style={{ 
                    fontSize: "14px", 
                    width: "60px", 
                    padding: "2px", 
                    textShadow: '2px 2px 4px rgb(61, 61, 61)' 
                  }}
                >
                  Удалить
                </button>

                <span 
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#bebebe",
                    textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
                  }}
                >
                  Восстановление доступно в течение 24 часов
                </span>
              </>
            )}

            </div>
          )}

                {/* Блок с текстом Fob */}
         {(isVisibleDescription && selectedComponent === FOB) && (
          <div style={{ flex: 1, marginRight: '10px', marginLeft: '10px', border: '1px solid gray',  borderRadius: '8px',  boxShadow: '2px 2px 6px black', padding: '10px', marginTop: '5px'  }}>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #000000ff' }}>Описание</label>
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Город: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{cityFob}</span> </label>
            <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !cantonFob ? '#f55a5aff' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {cantonFob
                    ? regionFob && areaFob
                      ? `${cantonFob} ${regionFob} ${areaFob}`
                      : cantonFob
                    : 'нет'}
                </span>
              </label>    
            <hr className="horizontalLineModal" />
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Фоб: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{fobName}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold'}}>Ранг: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{rankComponentNameFob}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Координаты: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{latitudeFob}, {longitudeFob}</span></label>
            <br/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Внес: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{authorIdFob}</span></label>    
            <br />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Комментарий: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #000000ff' }}>{descriptionFob}</span></label>
             <hr className="horizontalLineModal" />
              {statusFob !== 1 && (
                <label style={{ color: '#292929', fontWeight: 'bold'}}>
                  Статус:{' '}
                  <span
                    style={{
                      color: statusFob === 0 ? '#f55a5aff' : '#bebebe',
                      fontWeight: 'normal',
                      textShadow: '2px 2px 4px #000000ff'
                    }}
                  >
                    {statusFob === 0 ? 'Удален' : statusFob}
                  </span>
                </label>
              )}
                {/* Блок удаления — виден только если статус 1 и автор совпадает */}
            {statusFob === 1 && user === authorIdFob && (
              <>
                <button 
                  className="buttonIsDeleteModal" 
                  onClick={deleteComponent} 
                  style={{ 
                    fontSize: "14px", 
                    width: "60px", 
                    padding: "2px", 
                    textShadow: '2px 2px 4px rgb(61, 61, 61)' 
                  }}
                >
                  Удалить
                </button>

                <span 
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    color: "#bebebe",
                    textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
                  }}
                >
                  Восстановление доступно в течение 24 часов
                </span>
              </>
            )}
            </div>
          )}
         

    </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>    
    </Dialog>
  );
}

export default ModalSearchComponentMap;